export default __webpack_public_path__ + "static/media/bunny-showcase-3.aac3811b.png";